import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c4bb12e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5c4bb12e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4bb12e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\crmeb\\gitcode\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4bb12e')) {
      api.createRecord('5c4bb12e', component.options)
    } else {
      api.reload('5c4bb12e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c4bb12e&scoped=true", function () {
      api.rerender('5c4bb12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/pageConfig/index.vue"
export default component.exports